import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DistributorListRes;
export const DistributorListTodo = createAsyncThunk('DistributorList', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'distributor_list',
            data: {
                "vcust_plant_code": "CPL/01/494",
            },
            headers: { "Content-Type": "application/json" }
        })
        return DistributorListRes = res.data

    } catch (error) {
        return DistributorListRes = error.response.data
    }
})

const DistributorListSlice = createSlice({
    name: 'DistributorList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(DistributorListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(DistributorListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default DistributorListSlice.reducer; 